import { reportingUrlv2 } from "../../reportingBaseUrl";

export const reportingDownloadFileUrl = `${reportingUrlv2}/BulkExport/file`;
export const reportingDownloadFileKey = "reportingDownloadFileUrl";
